import { LAUNCH_CITIES, LAUNCH_CITY_RADIUS_MILES } from 'constants/launchCities';
import { calculateHaversineDistance } from 'utils/shared/geo/calculateHaversineDistance';

interface GeoPoint {
  latitude?: number | string | null;
  longitude?: number | string | null;
}

export const isLaunchCityMarket = (point?: GeoPoint | null) => {
  const latitude = Number(point?.latitude);
  const longitude = Number(point?.longitude);

  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    return false;
  }

  return LAUNCH_CITIES.some((city) => {
    const distance = calculateHaversineDistance({
      coord1: { latitude, longitude },
      coord2: { latitude: city.latitude, longitude: city.longitude },
      unit: 'miles',
    });

    return distance <= LAUNCH_CITY_RADIUS_MILES;
  });
};
